import { Anchor, Group, Text, Tooltip } from '@mantine/core';
import { IconInfoCircle } from '@tabler/icons-react';
import React from 'react';

interface CalendarAccessWarningProps {
    label: string;
    tooltip: string;
    reconnectLabel?: string;
    onReconnect?: () => void;
}

const CalendarAccessWarning: React.FC<CalendarAccessWarningProps> = ({
    label,
    tooltip,
    reconnectLabel,
    onReconnect,
}) => (
    <Group gap="xs" align="center" style={{ display: 'inline-flex', width: 'fit-content' }}>
        <Tooltip
            multiline
            maw={300}
            label={tooltip}
            withArrow
            position="top"
            events={{ hover: true, focus: true, touch: true }}
        >
            <Group gap={4} style={{ cursor: 'help', display: 'inline-flex', width: 'fit-content' }}>
                <IconInfoCircle size={16} color="red" />
                <Text c="red" size="sm" fw={500}>{label}</Text>
            </Group>
        </Tooltip>
        {onReconnect != null && reconnectLabel != null &&
            <Anchor component="button" type="button" size="sm" onClick={onReconnect}>
                {reconnectLabel}
            </Anchor>
        }
    </Group>
);

export default CalendarAccessWarning;
